/** The invite code in a link to this Atrium (https://<this host>/invite/<code>), or null for any other link. */
export function inviteCodeFromUrl(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.host !== window.location.host) return null;
    return u.pathname.match(/^\/invite\/([A-Za-z0-9_-]{4,32})\/?$/)?.[1] ?? null;
  } catch {
    return null;
  }
}

/** Invite codes linked in a message, first few only. */
export function inviteCodesIn(text: string, max = 3): string[] {
  const codes = (text.match(/https?:\/\/[^\s<>]+/g) ?? []).map(inviteCodeFromUrl).filter((c): c is string => !!c);
  return [...new Set(codes)].slice(0, max);
}
